import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=5bd50e82"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=5bd50e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports